module.exports = __webpack_public_path__ + "icons/original/large/large-b1.67391202fba98a1797a9c666a9f2d723.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-b1.png
// module id = UBU4
// module chunks = app